//export const BASE_URL = 'http://127.0.0.1:8000/api';
//export const BASE_URL = 'https://radio365.onrender.com/api';
export const BASE_URL = 'https://api.radiogo.gr/api';